module.exports = __webpack_public_path__ + "static/img/7.a8d8e80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/7.png
// module id = Ukh6
// module chunks = 0